export default "__VITE_ASSET__DLP4vsfp__"